import { Clear } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { useSelector } from 'react-redux'
import { getIsManagement } from '../../store/redux/reducers/currentUserSlice'
import { RootState } from '../../store/redux/store'

type Props = {
  index: number
  onRemove: (index: number) => void
}

const VacationPeriodRemoveButton = ({ index, onRemove }: Props) => {
  const isManagement = useSelector((state: RootState) => getIsManagement(state))

  if (!isManagement) return null

  return (
    <IconButton
      aria-label={'clear-vacation-period'}
      size="small"
      onClick={() => onRemove(index)}
      sx={{
        color: 'text.base',
        transition: 'all 150ms ease-in-out',
        ml: 1,
        '&:hover': {
          color: 'text.highEmphasis',
          bgcolor: 'primary.hoverTransparent',
        },
        '& svg': {
          width: 14,
          height: 14,
        },
      }}
    >
      <Clear />
    </IconButton>
  )
}

export default VacationPeriodRemoveButton
